import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=bf2f64b2&scoped=true"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./wysiwyg.vue?vue&type=style&index=0&id=bf2f64b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f64b2",
  null
  
)

export default component.exports